import React from 'react';
import { withRouter } from 'react-router-dom';
import { inject } from 'mobx-react';
import strings from '../../lang/strings.js';
import $ from 'jquery';
import { PageSettings } from "../../config/page-settings";
import { Panel, PanelBody, PanelHeader } from '../../components/panel/panel.jsx';
import DataTable from './../../components/content/data-table.jsx';
import SearchInput from './../../components/content/search-input.js';
import SearchSelect from './../../components/content/search-select.js';
import './../../config/util';
import Const from './../../config/const';
import MemberDetailPopup from './../member-detail/member-detail-popup'
const queryString = require('query-string');

class Now extends React.Component {
    static contextType = PageSettings;

    constructor(props) {
        super(props);

        let searchQS = queryString.parse(this.props.location.search);

        this.state = {
            search_info: searchQS,
            show_member_profile: false,
            selected_uid: 0
        };

        this.showMemberDetailPopup = this.showMemberDetailPopup.bind(this);
        this.refreshTable = this.refreshTable.bind(this);
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.location.search != this.props.location.search) {
            let searchQS = queryString.parse(this.props.location.search);
            this.setState({ search_info: searchQS }, () => this.refreshTable());
        }
    }

    refreshTable = (refresh) => {
        this.tblMember.draw(refresh);
    };

    searchTable = () => {
        let searchQS = queryString.parse(this.props.location.search);
        Object.assign(searchQS, this.state.search_info)
        const new_query = queryString.stringify(searchQS);
        if (new_query == this.props.location.search.substr(1)) {
            this.refreshTable();
        } else {
            this.props.history.push('?' + new_query);
        }
    }

    showMemberDetailPopup(uid) {
        this.setState({
            show_member_profile: true,
            selected_uid: uid
        });
    }

    render() {
        let self = this;
        let columnNo = 0;
        const { search_info } = this.state;

        return (
            <div>
                <Panel>
                    <PanelHeader noButton={true}>{strings.menu.now_list}</PanelHeader>
                    <PanelBody>
                        <MemberDetailPopup isOpen={this.state.show_member_profile} uid={this.state.selected_uid} onClose={() => {
                            this.setState({ show_member_profile: false });
                        }} />

                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='form-horizontal form-inline'>
                                    {/* 키워드검색 */}
                                    <SearchSelect
                                        data={strings.const.SEARCH_CATEGORY2}
                                        value={search_info.column || strings.const.SEARCH_CATEGORY2[0].code}
                                        onChange={(value) => {
                                            this.setState({
                                                search_info: {
                                                    ...search_info,
                                                    column: value,
                                                    start: 0,
                                                }
                                            }, this.searchTable);
                                        }}
                                    />
                                    <SearchInput
                                        value={search_info.keyword}
                                        onChange={(value) => {
                                            this.setState({
                                                search_info: {
                                                    ...search_info,
                                                    keyword: value,
                                                    column: search_info.column || strings.const.SEARCH_CATEGORY2[0].code,
                                                    start: 0,
                                                }
                                            })
                                        }}
                                        handler={(value) => this.searchTable()}
                                    />

                                    <button type='button' className='btn btn-success btn-sm ml-md-2' onClick={() => this.searchTable()}>{strings.search}</button>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 mt-3'>
                                <DataTable ref={(ref) => this.tblMember = ref}
                                    customPaginate={true}
                                    initialPage={search_info.start || 0}
                                    onPageChange={(value) => {
                                        this.setState({
                                            search_info: {
                                                ...search_info,
                                                start: value,
                                            }
                                        }, this.searchTable);
                                    }}
                                    options={{
                                        columnDefs: [
                                            {
                                                targets: [columnNo++], data: 'id', orderable: false,
                                                render: function (value) {
                                                    return value;
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'user_id', orderable: false,
                                                render: function (value) {
                                                    return value;
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'profile_image', orderable: false,
                                                createdCell: function (td, value, item) {
                                                    if (!value) {
                                                        return $(td).html(`(${strings.not_verified})`);
                                                    } else {
                                                        return $(td).image_lightbox(value, () => {
                                                            self.context.showGallery(value.split('#').map((it) => { return Const.BASE_URL + it }))
                                                        });
                                                    }
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'nickname', orderable: false,
                                                createdCell: function (td, value, item) {
                                                    return $(td).nickname_label(value, item.gender, () => {
                                                        self.showMemberDetailPopup(item.id);
                                                    });
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'status', orderable: false,
                                                render: function (value) {
                                                    return Number(value).status2String();
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'birthday', orderable: false,
                                                render: function (value) {
                                                    return value
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'gender', orderable: false,
                                                render: function (value) {
                                                    return value.gender2String();
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: null, orderable: false,
                                                createdCell: function (td, value, item) {
                                                    return $(td).html(item.school ? item.school : item.job);
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'signup_date', orderable: false,
                                                render: function (value) {
                                                    return value;
                                                }
                                            },
                                            {
                                                targets: [columnNo++], data: 'login_date', orderable: false,
                                                render: function (value) {
                                                    return value;
                                                }
                                            },
                                        ],
                                        order: [[1, 'DESC']],
                                        ajax: {
                                            url: 'member/getList',
                                            data: function (req) {
                                                req.columns = null;

                                                const searchQS = queryString.parse(self.props.location.search);
                                                req.start = searchQS.start || 0;
                                                req.length = searchQS.length || 20;
                                                req.column = searchQS.column;
                                                req.keyword = searchQS.keyword;
                                                req.now = 'Y';
                                            }
                                        },
                                        drawCallback: function () {
                                        },
                                        fnCreatedRow: function (row, data, dataInd) {
                                        }
                                    }}>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>{strings.user_id}</th>
                                            <th>{strings.profile}</th>
                                            <th>{strings.nickname}</th>
                                            <th>{strings.status}</th>
                                            <th>{strings.birthday}</th>
                                            <th>{strings.gender}</th>
                                            <th>{strings.school_job}</th>
                                            <th>{strings.first_signup_date}</th>
                                            <th>{strings.latest_login_date}</th>
                                        </tr>
                                    </thead>
                                    <tbody />
                                </DataTable>
                            </div>
                        </div>
                    </PanelBody>
                </Panel>
            </div>
        )
    }
}

export default withRouter(inject('rootStore')(Now));